import React, { Component } from "react";

export default (loadingProp, minLoadingTime = 1500) => Wrapped =>
  class MinLoader extends Component {
    state = {
      isLoading: this.props[loadingProp],
      startedLoadingAt: Date.now()
    };

    componentDidUpdate(prevProps) {
      if (!this.props[loadingProp] && prevProps[loadingProp]) {
        setTimeout(() => {
          this.setState({ isLoading: false, startedLoadingAt: 0 });
        }, minLoadingTime - (Date.now() - this.state.startedLoadingAt));
      } else if (this.props[loadingProp] && !prevProps[loadingProp]) {
        this.setState({ isLoading: true, startedLoadingAt: Date.now() });
      }
    }

    props;

    render() {
      return (
        <Wrapped {...this.props} {...{ [loadingProp]: this.state.isLoading }} />
      );
    }
  };
